import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { IconComponent } from '@tess-core/shared';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'tess-theme-toggle',
  imports: [IconComponent],
  templateUrl: './theme-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent {
  readonly theme = inject(ThemeService);

  toggle(): void {
    this.theme.toggle();
  }
}
